Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.CompareNumber = (function () {

    function CompareNumber () {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.createBaseStructure();

        this.createElement = function () {
            this.rootEl.className += ' compareNumberField';

            const options = [
                {
                    title: Monet.I18n.getResourcesByKey('compareNumberField.greaterThan'),
                    value: ">="
                },
                {
                    title: Monet.I18n.getResourcesByKey('compareNumberField.lessThan'),
                    value: "<="
                },
                {
                    title: Monet.I18n.getResourcesByKey('compareNumberField.equals'),
                    value: "="
                },
            ];
            
            this.comparationSelect = document.createElement('select');
            this.comparationSelect.className = 'comparationSelect';
            options.forEach((item) => {
                const option = document.createElement("option");
                option.value = item.value;
                option.text = item.title;
                this.comparationSelect.appendChild(option);
            });

            this.input = document.createElement('input');
            this.input.type = "number";
            this.input.min = "0";
            this.input.max = "9999";
            this.input.addEventListener('keydown', (ev) => {
                const keycode = event.keyCode || event.charCode;
                // Check if keycode isn't DELETE, BACKSPACE, LEFT ARROW OR RIGHT ARROW
                if ((ev.key === "." || ev.key === ",") || (ev.target.value.length === 4 && (keycode !== 8 && keycode !== 46 && keycode !== 37 && keycode !== 39))) {
                    ev.preventDefault();
                }
            });

            this.rootEl.appendChild(this.comparationSelect);
            this.rootEl.appendChild(this.input);

            if(this.hasAnd) {
                const andLabel = document.createElement("label");
                andLabel.className = "andLabel";
                const andTextNode = document.createTextNode(Monet.I18n.getResourcesByKey('compareNumberField.and'));
                andLabel.appendChild(andTextNode);
                this.rootEl.appendChild(andLabel);
            }
        };

        this.setMeta = function (meta) {
            if(meta && typeof meta === 'string'){
                meta = JSON.parse(meta);
                this.setOptions(meta);
            }
            this.meta = meta;
        };

        this.getInputValue = function () {
            if (this.input) {
                return parseInt(this.input.value);
            }
            return null;
        };

        this.getComparationSelectValue = function () {
            if (this.comparationSelect) {
                return this.comparationSelect.value;
            }
            return null;
        };

        this.setValue = (data) => {
            if(typeof data === 'object') {
                this.setInputValue(data.value);
                this.setComparationSelectValue(data.operator);
            }
        };

        this.setInputValue = function (value) {
            if (value || value === '' || value === 0) {
                this.input.value = value;
            }
        };

        this.setComparationSelectValue = function (value) {
            if (value || value === '' || value === 0) {
                this.comparationSelect.value = value;
            }
        };

        this.isEmpty = function () {
            var comparationSelectValue = this.getComparationSelectValue();
            var inputValue = this.getInputValue();
            return !((comparationSelectValue) && (inputValue || inputValue === 0));
        };

        this.clear = function (){
            this.setInputValue('');
            this.setComparationSelectValue('>=');
        };

        this.setHasAnd = function() {
            this.hasAnd = this.meta && this.meta.hasAnd;
        }

        this.render = function () {
            this.setHasAnd();
            this.createElement();
            return this.rootEl;
        };
    }

    return CompareNumber;
}());